/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-04-21 16:04:21
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-06-07 12:36:01
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesChannelContentEditor/SalesChannelContentPage/EditorPage/Preview/index.tsx
 */
/**
 *  Header component for sales channel layout.
 *  Author: Luke
 *  CreatedAt: 2021-03-04
 */

import React from 'react';

import { useSelector } from 'react-redux';

import { Preview as _Preview } from '@/src/constrains';
import { ErrorBoundary } from 'src/components/ErrorBoundary';

import {
  getContent,
  getOrder,
  getIconStyle,
  getCollapseStatus,
  getFloatingActionsBar,
  onCollapseOpen,
} from '../slice';

//import { productsInit } from '@/src/request/product/product'; //暂时link

const Preview = (props) => {
  const order = useSelector(getOrder());

  // const data = useSelector((state) => state.salesChannelContent.homepage);
  // console.log(data);

  return (
    <ErrorBoundary>
      <_Preview
        order={order}
        getContent={getContent}
        getIconStyle={getIconStyle}
        getCollapseStatus={getCollapseStatus}
        getFloatingActionsBar={getFloatingActionsBar}
        onCollapseOpen={onCollapseOpen}
      />
    </ErrorBoundary>
  );
};

export default Preview;
